

import axios from "axios";
import Config from '../configs';
// @ts-ignore
import {get} from 'lodash';
import { notification } from "antd";
import { redirect } from "react-router-dom";
import RoutePath from "../app/routing/routes.path";

function HandleError(error: any, {msgKey}: any) {
    const statusCode = get(error, 'response.status') ;
    if (statusCode == 401) {
        localStorage.clear();
        redirect(RoutePath.login);
    }
    const errorMessage = get(error, 'response.data.message') 
    || get(error, 'response.statusText')
    || error.toString();
    notification.error({
        key: msgKey || 'main',
        message: errorMessage
    })
    throw error;
}

export async function Get(urlPath: string,{msgKey}: any){
    const token = localStorage.getItem('token');
    if (!token) {
        return;
    }
    try { 
        const response = await axios.get(`${Config.baseUrl}${urlPath}`, {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Authorization": token,
            }
        })
        return get(response, 'data.data');
    } catch (error: any) {
        HandleError(error, {msgKey});
    }
}

export async function Put(urlPath:string, body:any, {msgKey}: any) {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.put(`${Config.baseUrl}${urlPath}`, body, {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Authorization": token,
            }
        })
        return get(response, 'data.data');
    } catch (error:any) {
        HandleError(error, {msgKey});
    }
}

export async function Delete(urlPath:string, {msgKey}: any) {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.delete(`${Config.baseUrl}${urlPath}`, {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Authorization": token,
            }
        })
        return get(response, 'data.data');
    } catch (error:any) {
        HandleError(error, {msgKey});
    }
}

export async function Post(urlPath:string, body:any, {msgKey}: any) {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.post(`${Config.baseUrl}${urlPath}`, body, {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Authorization": token,
            }
        })
        return get(response, 'data.data');
    } catch (error:any) {
        HandleError(error, {msgKey});
    }
}